import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';


// third-party
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import Locales from 'components/Locales';

// fonts
import 'assets/fonts/inter/inter.css';

// scroll bar
import 'simplebar-react/dist/simplebar.min.css'; 
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// apex-chart
import 'assets/third-party/apex-chart.css';
import 'assets/third-party/react-table.css';

// project-imports
import App from './App';
import { store, persister } from 'store';
import { ConfigProvider } from 'contexts/ConfigContext';
import reportWebVitals from './reportWebVitals';
import { APP_BASE_NAME } from './config';
import { IntlProvider } from 'react-intl';
import { QueryClient, QueryClientProvider } from 'react-query';





const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});
const container = document.getElementById('root');
const root = createRoot(container!);

// ==============================|| MAIN - REACT DOM RENDER  ||============================== //

root.render(

  <ReduxProvider store={store}>
    <QueryClientProvider client={queryClient}>
      <PersistGate loading={null} persistor={persister}>
        <ConfigProvider>
          <Locales>
            <BrowserRouter basename={APP_BASE_NAME}>
              <IntlProvider locale="en">
                <App />
              </IntlProvider>
            </BrowserRouter>
          </Locales>
        </ConfigProvider>
      </PersistGate>
    </QueryClientProvider>
  </ReduxProvider>

);


reportWebVitals();
